import api from '../utils/api';
import localStorageService from './localStorageService';
import { STAT_CREW_ADDON_API } from '../constants/routes';

class AddonService {
  public getStatCrewAddon = async (sportCode: string) => {
    const userInfo = localStorageService.getUserInfo();
    const token = userInfo?.access_token || '';

    return api.get(STAT_CREW_ADDON_API, {
      params: {
        sport_code: sportCode,
      },
      headers: { Authorization: `Bearer ${token}` },
    });
  };
}

const addonService = new AddonService();
export default addonService;
